module.exports = __webpack_public_path__ + "static/02 fibonacci--law-firm-f8d7fd1d9d9446d7a94e319471d20ca4.svg";